import React, { forwardRef, Ref, SVGAttributes } from 'react';

const ArrowRight = forwardRef((props: SVGAttributes<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    ref={ref}
    width="18"
    height="14"
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.086 7.99993H1.5C0.947715 7.99993 0.5 7.55221 0.5 6.99993C0.5 6.44764 0.947715 5.99993 1.5 5.99993H14.0859L10.5001 2.41414C10.1096 2.02361 10.1096 1.39045 10.5001 0.999924C10.8906 0.6094 11.5238 0.6094 11.9143 0.999924L17.2072 6.29282C17.5977 6.68333 17.5977 7.31648 17.2072 7.70701L11.9143 13.0002C11.5238 13.3908 10.8906 13.3908 10.5001 13.0003C10.1096 12.6098 10.1095 11.9766 10.5001 11.5861L14.086 7.99993Z"
      fill="white"
    />
  </svg>
));

export default ArrowRight;
